import type { CSSProperties } from 'react';

/**
 * A style object that may also carry custom properties.
 *
 * Components accept spacing and column counts as CSS variables rather than as concrete
 * declarations, so a view can tune rhythm without the component knowing anything about
 * where it sits. React's CSSProperties has no index signature for `--*`, hence this.
 */
export type StyleVars = CSSProperties & Record<`--${string}`, string | number | undefined>;

/** Drops undefined entries so an unset prop does not emit an empty custom property. */
export function styleVars(
  input: Record<`--${string}`, string | number | undefined>,
  base?: CSSProperties,
): StyleVars | undefined {
  const out: StyleVars = { ...base };
  let count = 0;

  for (const key of Object.keys(input) as Array<`--${string}`>) {
    const value = input[key];
    if (value !== undefined) {
      out[key] = value;
      count += 1;
    }
  }

  return count === 0 && !base ? undefined : out;
}
